import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import type { Database } from '@/types/database';

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  // Demo mode (no env vars) is expected on first boot and stays that way for
  // every preview surface. Hooks that need Supabase fall back to MOCK_*
  // fixtures via isSupabaseConfigured(). We log once at module init so the
  // dev knows; no further noise across navigations.
  console.info(
    '[supabase] env vars unset — running in demo mode (mock fixtures, no persistence).',
  );
}

export const supabase: SupabaseClient<Database> = createClient<Database>(
  url ?? 'https://placeholder.supabase.co',
  anonKey ?? 'placeholder-anon-key',
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      storageKey: 'fitfive-auth',
    },
    global: {
      headers: {
        'x-app-version': '0.1.0',
      },
    },
  },
);

export function isSupabaseConfigured(): boolean {
  return Boolean(url && anonKey);
}
